<template>
  <div class="story">
    <slot name="backbtn" :isGoBackPossible="isGoBackPossible" :goBack="goBack" />

    <div class="story__blur-bg" v-if="screenSize !== 'small'">
      <div class="story__blur-content" :style="storyBackground"/>
    </div>

    <a href="/" class="story__logo" v-tag:useractionevent="{ category: 'main menu', action: 'select::header', label: 'logo' }">
      <slot name="logo" />
    </a>

    <div class="story__system-btns">
      <slot name="ally" />
    </div>

    <div class="story__wrapper" ref="storyWrapper">
      <slider
        :aria-roledescription="a11yRole"
        :per-page="1"
        :navigation-enabled="true"
        :pagination-enabled="false"
        :swipe-on-desktop="true"
        :is-slide-loader="true"
        :partial-visible-slide="true"
        :screen-size="screenSize"
        @pageChange="getBackground"
      >
        <slot />
      </slider>
    </div>
  </div>
</template>

<script>
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';
  import { checkScreenSize } from '@Foundation/mixins/checkScreenSize';
  import { tag } from '@Foundation/analyticsHandler/directives/tag.js';

  export default {
    name: 'story',

    components: {
      'slider': () => import('@Foundation/Slider/code/Scripts/components/slider/slider'),
    },

    directives: {
      tag
    },

    mixins: [checkScreenSize],

    props: {
      initialBackground: { type: String, default: '' },
      a11yRole: { type: String, default: 'carousel' }
    },

    data() {
      return {
        carouselBg: this.initialBackground,
        slidesBgArray: null
      };
    },

    computed: {
      storyBackground() {
        return `background-image: ${this.carouselBg}`;
      },
      isGoBackPossible() {
        return document.referrer !== '' && window.history.length > 1;
      }
    },

    mounted() {
      /**
       * set slides array
       */
      setTimeout(() => {
        this.slidesBgArray = document.querySelectorAll('.image--slideCard .responsive-image__media img, [poster]');
      }, 1000);
    },

    methods: {
      goBack() {
        this.isGoBackPossible && window.history.go(-1);
      },

      getBackground(currentPage = 0, prevPage) {
        setTimeout(() => {
          const slideId = this.$el
            .querySelector('.slider__slide.active')
            .getAttribute('id');
          this.sliderAnalytics(currentPage, prevPage, slideId);
        }, 200);

        !!this.slidesBgArray[currentPage] && this.slidesBgArray[currentPage].nodeName !== 'VIDEO' ? this.carouselBg = `url(${this.slidesBgArray[currentPage].getAttribute('src')})` : this.carouselBg = `url(${this.slidesBgArray[currentPage].getAttribute('poster')})`;
      },

      sliderAnalytics(currentPage, prevPage, slideId) {
        AnalyticsHandler.pushDataLayer({
          event: 'uaevent',
          ecommerce: undefined,
          eventCategory: 'content',
          eventAction: 'select::story',
          eventLabel: `${currentPage > prevPage ? 'right' : 'left'}::${slideId}`
        });
      }
    }
  };
</script>

<style lang="scss" src="./story.scss">
</style>
